import { render, staticRenderFns } from "./PersonContactOnly.vue?vue&type=template&id=14486757&scoped=true&"
import script from "./PersonContactOnly.vue?vue&type=script&lang=js&"
export * from "./PersonContactOnly.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=14486757&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14486757",
  null
  
)

export default component.exports